<template>
  <div>
     <b-carousel
          id="carousel-1"
          v-model="slide"
          :interval="4000"
          fade
          background="#ababab"
          style="text-shadow: 1px 1px 2px #333;"
          @sliding-start="onSlideStart"
          @sliding-end="onSlideEnd"
        >
          <!-- Text slides with image -->
          <b-carousel-slide
            v-for="item in data_carousel"
            :key="item.title"
            :img-src="$domainPrefix + item.image"
          ></b-carousel-slide>
       </b-carousel>

  </div>
</template>

<script>
export default {
    data () {
        return {
            data_carousel: [],
            slide: 0,
            sliding: null
        }
    },
    created () {
        var that = this
        this.$axios.get('/api/getslideshow/')
            .then(function (response) {
                that.data_carousel = response.data
            })
            .catch(function (error) {
                console.log(error)
            })
    },
    methods: {
        onSlideStart (slide) {
            this.sliding = true
        },
        onSlideEnd (slide) {
            this.sliding = false
        }
    }
}
</script>

<style>
  .white {
    color: #FFFFFF;
  }
</style>
